<template>
    <div class="row">
        <div class="col-md-12">
            <h2 class="text-center">Autoryzacja w toku...</h2>
            <loader :active="loading" />
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Login',
        data() {
            return {
                token: '',
                dbid: '',
                loading: true,
                message: '',
            };
        },
        computed: {
            loggedIn() {
                return this.$store.state.auth.status.loggedIn;
            }
        },
        mounted() {
            this.dbid = this.$route.params.dbid;
            this.token = this.$route.params.token;
            this.websiteLogin();
        },
        methods: {
            websiteLogin() {
                this.$store.dispatch('auth/websiteLogin', {dbid: this.dbid, token: this.token}).then(
                    () => {
                        this.message = '';
                        this.$router.push('/home');
                    },
                    error => {
                        this.loading = false;
                        this.message = "Undefinded error";

                        if (error.response && error.response.data && error.response.data.message)
                            this.message = error.response.data.message;
                        else if (error.message)
                            this.message = error.message;
                        else if (error.toString())
                            this.message = error.toString();
                    }
                );
            }
        }
    };
</script>

<style scoped>
</style>